import { jsx } from 'react/jsx-runtime';
import { FavoritesConsumer } from '@sbt-web/favorites';
import { Icon, IconSize, Palette } from '@sbt-web/ui';
import styles from './index.module.css.js';

const FavoriteButton = ({ item }) => {
    return jsx(FavoritesConsumer, { urn: item.urn, children: FavButtonUI });
};
const FavButtonUI = ({ status, onClick }) => {
    const iconProps = buildIconProps(status);
    const ariaLabel = status === 'active' ? 'Rimuovi dai preferiti' : 'Aggiungi ai preferiti';
    return (jsx("button", { type: "button", onClick: onClick, className: styles.favButton, "aria-label": ariaLabel, "aria-pressed": status === 'active', children: jsx(Icon, { iconSize: IconSize.SM, ...iconProps }) }));
};
function buildIconProps(status) {
    switch (status) {
        case 'active':
            return {
                name: 'FavoriteActive',
                fillColor: Palette.RedCorporate,
            };
        case 'inactive':
        default:
            return {
                name: 'FavoriteInactive',
                fillColor: Palette.NeutralGrey2,
            };
    }
}

export { FavButtonUI, FavoriteButton };
//# sourceMappingURL=index.js.map
